import React,{useEffect} from "react";

import "./Eeedept.css";
import {
  Backtotop,
  Floatinmenu,
  Underline,
  Deptmission,
  Deptvision,
  ContentCard
} from "../../widgets";
import {
  eee_dept_menu,
  eee_mission,
  eee_vision,
  eee_progs,
  eee_hod
} from "../../constants/eee_dept";

import { RadialMenu,Hodmsg } from "../../components";
//import eee from "../../assets/pictures/eee_about.webp";

import { AiFillThunderbolt } from "react-icons/ai";


const eee="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Eee/eee_about.webp"
const Eeedept = () => {
  useEffect(() => {
    document.title = 'ACCET-EEE Department';
  }, []);
  return (
    <div className="eeedept">
      <div className="eeebg">
        <div className="eeeheading">
          Department of Electrical and Electronics Engineering
        </div>
      </div>
      <section className="eeedark">
        <div className="dept_float_menu">
          <Floatinmenu
            logo={AiFillThunderbolt}
            head="Menu"
            links={eee_dept_menu}
          />
        </div>
        <RadialMenu menu_links={eee_dept_menu} />


        <div className="eee_abt">
          <Underline heading="About the Department" />
          <div className="eeetwo-col">
            <p className="eee_dept_content">
              Electrical and Electronic Engineers work at the forefront of
              practical technology. This field of Engineering and Technology has
              a major contribution to society, which we are enjoying and
              witnessing today. This importance makes the Electrical and
              Electronics Engineering branch to stay ever green on top of all
              other Engineering branches as well. Our department was started in
              1952. Faculty members are working with around 600 students of
              undergraduate, postgraduate, and research programmes.
            </p>
            <div className="dept_img_holder">
              <img className="dept_img" src={eee} />
            </div>
          </div>
          <div className="eeetwo-col1">
            <p className="eee_dept_content">
              Its our pleasure and pride to provide highly skilled technological
              manpower to solve interesting problems at various renowned
              Electrical And Electronics Industries. To keep our academic
              programmes inline with the current industrial needs, with the help
              of all stakeholders continuous and concerted efforts are being
              taken to revamp the curriculum.
            </p>
            <p className="eee_dept_content">
              The department moves with a vision to produce competent and
              disciplined globally accepted Electrical Engineers. The department
              has state of the art facilities for various laboratories like
              Centre for Internet of Things “Next Gen Internet of Things
              Laboratory”, Smart Grid Laboratory, Special Electrical Machines
              Laboratory, Solar plants as well as classrooms to support
              e-learning through the department library.
            </p>
            <p className="eee_dept_content">
              For the past seven decades, the department has been producing
              numerous outstanding Engineers for the country. Many of our alumni
              have registered notable contributions in their industrial,
              research and academic professions. Guest lectures and industrial
              visits are periodically arranged for the students and faculty
              members to supplement their curriculum. The department strives for
              all round excellence in students. As a team, I wish to continue to
              provide outcome based quality education for the generations to
              come.
            </p>
          </div>
        </div>
        {/* <div className="eee_hod">
          <Underline heading="HOD's Message" />
          <Hodmsg name={eee_hod.name} designation={eee_hod.designation} pic={eee_hod.pic} content={eee_hod.content}/>
        </div> */}
        
        {/* <div className="eee_vdo_gallery_holder">
        <Underline heading="EEE Department Video Gallery" />
        <div className='home_clg_vdo_holder'>
          <video className='home_clg_vdo' controls autoPlay muted>
            <source src={eeevdo} type="video/mp4" />
          </video>
        </div>
        </div> */}

        <div className="eee_vision_mission">
          <Underline heading="Our Vision & Mission" />
          <Deptvision visiondata={eee_vision.visiondata} />
          <Deptmission points={eee_mission} />
        </div>

        <div className="eee_prog_offered">
          <Underline heading="Programs Offered"/>
          <div className="eee_progs">
            {eee_progs.map((item)=><ContentCard key={item.id} period={item.period} year={item.year} top_head={item.top_head} heading={item.program} intake={item.intake}/>)}
          </div>
        </div>
        <Underline heading="Department Video"/>
      <div className="eee-intro-vid">
      <iframe src="https://drive.google.com/file/d/1CnZKls7OOE2Ir0LQFOO7hd9qLktyqTM0/preview" className="eee-intro-vid-i"   allow="autoplay"></iframe>
      </div>
      </section>
      

      <Backtotop />
    </div>
  );
};

export default Eeedept;
